import React from "react";
import { callIcon } from "../../utils/historyIcons/historyIcons";

const BubblePhoneButton = ({ customer, disabled }) => {
  return (
    <>
      {disabled ? (
        <>
          <div className="max-w-sm p-6 cursor-not-allowed opacity-50">
            <p>
              <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                {callIcon(39, 39)}
              </h5>
            </p>
          </div>
        </>
      ) : (
        <a className="max-w-sm p-6 " href={`tel:${customer?.phoneNumber}`}>
          <p>
            <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
              {callIcon(39, 39)}
            </h5>
          </p>
        </a>
      )}
    </>
  );
};

export default BubblePhoneButton;
